import { createI18n } from "vue-i18n";
import ru from "./locales/ru.json";
import en from "./locales/en.json";
import kk from "./locales/kk.json";

const messages = {
    ru,
    en,
    kk,
};

const i18n = createI18n({
    locale:
        localStorage.getItem("preferred_language") ||
        document.documentElement.lang ||
        "ru",
    fallbackLocale: "en",
    messages,
});

export default i18n;
